<template>
  <v-container my-1 py-1 px-0>
    <v-layout>
      <v-flex>
        <v-card>

          <v-layout row wrap>
            <v-flex ml-4 mr-2 d-flex>
              <v-text-field v-model="searchText" label="Nombre de Campaña" append-icon="search" clearable></v-text-field>
            </v-flex>
            <v-spacer></v-spacer>

            <v-flex v-for="channel in allChannels" :key="channel" mx-2 justify-center d-flex>
              <v-switch v-model="selectedChannels" :label="channel" :value="channel"></v-switch>
            </v-flex>

          </v-layout>

        </v-card>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      searchText: "",
      selectedChannels: ["SMS", "email"],
      allChannels: ["SMS", "email"]
    };
  },
  methods: {
    changed() {
      this.$emit("input", {
        searchText: this.searchText,
        selectedChannels: this.selectedChannels
      });
    }
  },
  watch: {
    searchText() {
      this.changed();
    },
    selectedChannels() {
      this.changed();
    }
  },
  created() {
    this.changed();
  }
};
</script>
